module.exports = __webpack_public_path__ + "img/whatsapp-plus-anti-ban.c8629374.webp";